module.exports = __webpack_public_path__ + "img/collision.f1e75a0d.gif";